import { createFileRoute } from '@tanstack/react-router';
import { TransactionalDraftsRoute } from '@/pages/workspaces/transactional/message/overview/drafts/routing';

function TransactionalDraftsRouteComponent() {
  const { transactionalMessageId } = Route.useParams();
  return <TransactionalDraftsRoute transactionalMessageId={transactionalMessageId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview/drafts',
)({
  component: TransactionalDraftsRouteComponent,
});
